import { useQuery } from '@tanstack/react-query'

import { GetLeadsRepresadosService, type TGetLeadsRepresadosParams } from '../services/get-leads-represados.service'
import { clientesKeys } from '../utils/queries'

export const useListarLeadsRepresados = (query: Partial<TGetLeadsRepresadosParams>, enabled = false) =>
  useQuery({
    enabled,
    retry: false,
    queryKey: clientesKeys.leadsRepresados(query),
    queryFn: () =>
      new GetLeadsRepresadosService()
        .execute({ paginaCorrente: 1, tamanhoDaPagina: 20, ...(query ?? {}) })
        .then((response) => {
          return response
        }),
  })
